import App from "../../App";
import Layout from "../../utils/Layout";
import { IObjectConfig } from "../../baseConfigs/layoutConfigShema";
import { TextStyle, Container, Graphics, TextMetrics, Text, ObservablePoint } from "pixi.js";
import GameModel from "../../model/GameModel";
import { isArray } from "lodash";
import Locale from "../../utils/Locale";
import GameEvents from "../../const/GameEvents";
import { Tween } from '../../Tween';
import { Ease } from '../../Ease';
import Configs from '../../../../src/vendorConfigs/Configs';

class TextField extends Container {
    static fontMeasure: any = {};
    protected _fieldWidth: number;
    protected _fixFontSize: number | string = undefined;
    protected _fieldHeight: number;
    public bound: IObjectConfig;
    public boundShape: Graphics;
    protected textShape: Graphics;
    protected underline: Graphics;
    public boundAnchor: { x: number; y: number } = { x: 0, y: 0 };
    public initStyle: ITextFieldStyleOptions;
    public scrollable: boolean = false;
    public wrappable: boolean = true;
    public centeredVertically: boolean = false;
    protected newStyle: ITextFieldStyleOptions;
    protected _text: Text;
    private _isLabel: boolean;
    private originalBoundAnchor: { x: number; y: number; };
    protected boundsRect: Graphics;
    private alternative: boolean;

    constructor(
        text: string,
        style: ITextFieldStyleOptions,
        definition: {
            multistyle?: boolean;
            bound?: IObjectConfig;
            anchor?: { x: number; y: number };
        }
    ) {
        super();
        if (style.fontFamily && !isArray(style.fontFamily)) {
            let fontConfig = GameModel.gameConfig.fonts[style.fontFamily];
            if (fontConfig && fontConfig.padding) {
                style.padding = Number(style.fontSize) * fontConfig.padding;
                style.trim =
                    text != " " &&
                    text != null &&
                    text != undefined &&
                    text != "";
            };

            if (fontConfig && fontConfig.fontWeight) {
                style.fontWeight = fontConfig.fontWeight;
            };

            if (fontConfig && fontConfig.textBaseline) {
                style.textBaseline = fontConfig.textBaseline;
            };

            if (fontConfig && fontConfig.letterSpacing) {
                style.letterSpacing = fontConfig.letterSpacing;
            };
        };

        const styleUpdate = Configs?.components?.fieldStyleUpdate?.find(d => d.id === definition?.bound?.id);
        if (styleUpdate) {
            style = {...style, ...styleUpdate.style};
        }
        this.initStyle = { ...style } ;
        this._text = new Text(text, this.initStyle as TextStyle);
        this.textShape = new Graphics();
        this.underline = new Graphics();
        this.textShape.beginFill(0xfffb1b, 50);
        this.textShape.drawRect(
            0,
            0,
            Layout.scalePixels(this._text.width),
            Layout.scalePixels(this._text.height)
        );
        this.addChild(this._text);
        this.addChild(this.textShape);
        this.boundAnchor = definition.anchor;
        this.originalBoundAnchor = definition.anchor;
        if (definition.bound) {
            this.bound = definition.bound;
            // this.applyBound();
        }

        App.dispatcher.on(GameEvents.UI_UPDATE, () => { this.createBoundsRect(); }, this);
    }
    get fixFontSize(): number | string {
        return this._fixFontSize
    }
    // TO DO - Need to check for conditions for set the fixFontSize value
    set fixFontSize(value: number | string) {
        if (value !== this._fixFontSize) {
            this._fixFontSize = value;
        }
    }

    get anchor() {
        return this._text.anchor;
    }

    set anchor(anchor: ObservablePoint) {
        this._text.anchor = anchor;
        this.boundAnchor = anchor;
    }
    get element() {
        return this._text;
    }

    get text(): string {
        return this._text.text;
    }

    set text(text: string) {
        text = String(
            text === "" || text === null || text === undefined ? " " : text
        );
        if (this._text.text === text) {
            return;
        }
        if (this._text.style.padding) {
            this._text.style.trim = text != " ";
        }
        // this.dirty = true;
        this._text.text = text;

        // Apply the bounds - hide while positioning as currently it takes time
        // TODO: apply bounds needs to be refactored urgently!
        // this._text.visible = false;

        this.applyBound();
        // this._text.visible = true;
    }

    get style() {
        return this._text.style;
    }

    public get isLabel(): boolean {
        return this.isLabel;
    }

    public set isLabel(value: boolean) {
        this._isLabel = value;
    }

    public updateStyle(style: ITextFieldStyleOptions) {
        if(style.fill){
            this._text.style.fill = style.fill;
        }
        if(style.fontFamily && !isArray(style.fontFamily)){
            let fontConfig = GameModel.gameConfig.fonts[style.fontFamily];
            if (fontConfig && fontConfig.padding) {
                style.padding = Number(style.fontSize) * fontConfig.padding;
                style.trim =
                    this.text != " " &&
                    this.text != null &&
                    this.text != undefined &&
                    this.text != "";
            }

            if (fontConfig && fontConfig.fontWeight) {
                style.fontWeight = fontConfig.fontWeight;
            }

            if (fontConfig && fontConfig.textBaseline) {
                style.textBaseline = fontConfig.textBaseline;
            }
        }
        this.newStyle = { ...style } ;
        // TODO
    }

    public addUnderline() {
        this.underline.clear();
        let lineColor: string = this.style.fill[0];
        lineColor = lineColor.replace("#", "0x");
        let lineWidth = Math.max(
            Layout.scalePixels(this.bound.height) / 20,
            Layout.scalePixels(5)
        );
        let color = parseInt(lineColor);
        this.underline
            .lineStyle(lineWidth, color)
            .moveTo(0, 0)
            .lineTo(this.textShape.width, 0);
        // Migration to PIXI v6 requres pivot to be ObservablePoint instead of Point.
        this.underline.pivot = new ObservablePoint(
            null,
            null,
            this.underline.width * this.boundAnchor.x,
            0
        );
        this.underline.x =
            Layout.scalePixels(this.bound.width) -
            Layout.scalePixels(this.bound.width) * (1 - this.boundAnchor.x);
        this.underline.y =
            Layout.scalePixels(this.bound.height) + this.underline.height;
        this.addChild(this.underline);
    }

    public removeUnderline() {
        this.underline.clear();
    }

    protected createBoundsRect() {
        if (this.boundsRect && this.boundsRect.parent) {
            this.boundsRect.parent.removeChild(this.boundsRect);
            this.boundsRect.destroy();
        }

        this.boundsRect = new Graphics();
        this.boundsRect.beginFill(0xFF0000, 0.5);
        this.boundsRect.lineStyle(this.alternative ? 4 : 0, 0x000fff, 0.5);
        const w = Layout.scalePixels(this.bound.width);
        const h = Layout.scalePixels(this.bound.height);
        const x = this._text.position.x - this.anchor.x * w;
        const y = this._text.position.y - this.anchor.y * h;
        this.boundsRect.drawRect(x, y, w, h);
        this.boundsRect.endFill();
        if (!App.instance.debugBounds) {
            this.boundsRect.alpha = 0;
        }
        this.addChild(this.boundsRect);
    }

    public applyBound(multiplier = 1, calculateFontSize: boolean = true) {
        if (!this.bound) {
            return;
        }

        this.removeChild(this.textShape);
        const x = Layout.scalePixels(this.bound.x);
        const y = Layout.scalePixels(this.bound.y);
        const width = Layout.scalePixels(this.bound.width);
        const height = Layout.scalePixels(this.bound.height);

        if (this.bound.id && Locale.getString(this.bound.id) !== this.bound.id) {
            this._text.style.wordWrap = this.wrappable;
            this._text.style.wordWrapWidth = width;
            this._text.style.breakWords = true;

            if (this._isLabel) {
                this._text.style.fontSize = height * 0.6;
            } else {
                if (this.fixFontSize) {
                    this._text.style.fontSize = this.fixFontSize;
                } else {
                    if (calculateFontSize) {
                        let step = 1;

                        // Migration to PIXI v6 requres casting as TextStyle in order to clone
                        let style = (this._text.style as TextStyle).clone();
                        style.fontSize = GameModel.gameConfig.minFontSize || 10;
                        let metrix = TextMetrics.measureText(this._text.text, style, this.wrappable);

                        while (metrix.height < height) {
                            style.fontSize = Number(style.fontSize) + step;
                            metrix = TextMetrics.measureText(this._text.text, style, this.wrappable);
                        }

                        this._text.style.fontSize = Math.floor(Number(metrix.style.fontSize) - step) * multiplier;
                    }
                }
            }

            let newX = x + width * this.originalBoundAnchor.x;
            let newY = y + height * this.originalBoundAnchor.y;
            this._text.position.set(newX, newY);
            this.anchor.set(this.originalBoundAnchor.x, this.originalBoundAnchor.y);

        } else if (this._isLabel && App.config.labelSettings?.fontSizeUnification) {
            this._text.style.wordWrap = this.wrappable;
            this._text.style.wordWrapWidth = width;
            this._text.style.breakWords = true;

            let style = (this._text.style as TextStyle).clone();
            let measure = TextMetrics.measureText(this._text.text, style, this.wrappable);
            while (measure.height > height) {
                style.fontSize = Number(style.fontSize) - 1;
                measure = TextMetrics.measureText(this._text.text, style, this.wrappable);
            }
            this._text.style.fontSize = Math.floor(Number(measure.style.fontSize)) * multiplier;
            this._text.position.set(x, y);
            this.alternative = true;

        } else {
            this.removeChild(this.textShape);
            let style = (this._text.style as TextStyle).clone();
            style.fontSize = 100;
            const measure = TextMetrics.measureText(this._text.text, style);
            this._text.style.fontSize = style.fontSize * Math.min(width / measure.width, height / measure.height) * multiplier;
            this._text.position.set(x, y);
            this.alternative = true;
        }

        this.createBoundsRect();
    }

    public centerVertical() {
        if (this.scrollable) {
            return;
        }
        this.centeredVertically = true;
        const initStrokeOffset =
            (this._text.style.strokeThickness || 0) / Layout.globalScale;
        // Migration to PIXI v6 requres casting as TextStyle
        let measuredTxt: any = TextMetrics.measureText(
            this._text.text,
            this._text.style as TextStyle
        );

        let measuredHeight = measuredTxt.height / Layout.globalScale;

        Layout.setY(
            this,
            this.bound.y +
                (this.bound.height - measuredHeight * this.scale.y) / 2
        );
    }

    protected calculateTextMultiplier(): number {
        return Layout.isLandscape() ? 1 : Layout.portraitMultiplier;
    }

    public clone(): TextField {
        let clone = new TextField(this.text, this.initStyle, { bound: this.bound, anchor: this.originalBoundAnchor });
        return clone;
    }

    public playBounceEffect(duration: number, fromScale: number, toScale: number, onComplete?: Function, ease: Ease = Ease.BackOut2): void {
        let startHeight = this._text.height;
        Tween.fromTo(this._text.scale, duration, {
            x: fromScale,
            y: fromScale,
        }, {
            x: toScale,
            y: toScale,
            ease: ease
        })
        Tween.to(this._text, duration, {
            y: this._text.y - (((startHeight * toScale) - startHeight) / 2),
            ease: ease,
            onComplete: () => onComplete && onComplete()
        })
    }
}
export interface ITextFieldStyleOptions {
    align?: string;
    breakWords?: boolean;
    dropShadow?: boolean;
    dropShadowAlpha?: number;
    dropShadowAngle?: number;
    dropShadowBlur?: number;
    dropShadowColor?: string | number;
    dropShadowDistance?: number;
    fill?:
        | string
        | string[]
        | number
        | number[]
        | CanvasGradient
        | CanvasPattern;
    fillGradientType?: number;
    fillGradientStops?: number[];
    fontFamily?: string | string[];
    fontSize?: number | string;
    fontStyle?: string;
    fontVariant?: string;
    fontWeight?: string;
    leading?: number;
    letterSpacing?: number;
    lineHeight?: number;
    lineJoin?: string;
    miterLimit?: number;
    padding?: number;
    stroke?: string | number;
    strokeThickness?: number;
    trim?: boolean;
    textBaseline?: string;
    whiteSpace?: string;
    wordWrap?: boolean;
    wordWrapWidth?: number;
}
export default TextField;
